<template>
    <section class="section" id="cert" style="padding:50px 0;">
        <div class="container">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <h1>
                        Ваш сертификат за прохождение симулятора
                    </h1>
                    <h5 style="font-weight:normal">
                        Вы можете поделиться своим сертификатом с друзьями и коллегами. Мы будем очень благодарны Вам за отзыв!
                    </h5>
                    <div id='certificate' v-if="show">
                        <div class="cert_name">
                            Юрий<br>Клименко
                        </div>
                    </div>
                    <div id='cert_img'>
                        
                    </div>
                </div>
                
            </div>
            
        </div>
        
    </section>
</template>
<script>
import API from '@/api'
import * as htmlToImage from 'html-to-image';
export default {
  name: "Simulator",
  data() {
    return {
        show:true, 
        user:{}
    };
  },
  components: {},
  mounted() {
    
    var node = document.getElementById('certificate');
    htmlToImage.toPng(node)
    .then(function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        document.getElementById('cert_img').appendChild(img);
        this.show=false
    }.bind(this))
    .catch(function (error) {
        console.error('oops, something went wrong!', error);
    });
  },
  methods: {
    
  },
};
</script>
<style>
.cert_name
{
    font-size: 3.5vw;
    line-height: 1.2;
    color: #8cc9d6;
    font-weight: 700;
    position: absolute;
    top: 0;
    left: 23.2%;
    top: 18.5%;
}
#certificate
{
    position: relative;
    display: block;
    width: 60vw;
    height: 42.73vw;
    background-image: url('../assets/cert.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left top;
    border: 3px #8cc9d6 solid;
    
}
#cert_img img{
    width: 100%;
    max-width: 900px;
}
</style>
